import { Risco } from '../types';

// Função auxiliar para converter string numérica (aceita vírgula ou ponto)
export const parseNumero = (valor: string | number): number => {
  if (typeof valor === 'number') return valor;
  if (!valor || valor === '') return 1;
  // Substituir vírgula por ponto e remover espaços
  const valorLimpo = valor.toString().replace(',', '.').trim();
  const numero = parseFloat(valorLimpo);
  return isNaN(numero) ? 1 : numero;
};

// Função para calcular HRN
// Fórmula: HRN = PO × FE × GS × NP
export const calcularHRN = (po: number, fe: number, gs: number, np: number): number => {
  // Garantir que todos os valores sejam números válidos (preservar decimais pequenos)
  const poVal = (po != null && !isNaN(Number(po)) && Number(po) > 0) ? Number(po) : 1;
  const feVal = (fe != null && !isNaN(Number(fe)) && Number(fe) > 0) ? Number(fe) : 1;
  const gsVal = (gs != null && !isNaN(Number(gs)) && Number(gs) > 0) ? Number(gs) : 1;
  const npVal = (np != null && !isNaN(Number(np)) && Number(np) > 0) ? Number(np) : 1;
  return poVal * feVal * gsVal * npVal;
};

// Função para atualizar HRN quando os campos são alterados
// Fórmula: HRN = PO × FE × GS × NP
export const atualizarHRNRisco = (
  riscos: Risco[],
  index: number,
  campo: string,
  valor: string | number,
  tipo: 'atual' | 'futuro',
  setRiscosEditados: (riscos: Risco[]) => void
) => {
  const valorNumerico = parseNumero(valor);
  const novosRiscos = [...riscos];
  const risco = novosRiscos[index];
  
  if (tipo === 'atual') {
    if (campo === 'probabilidade') risco.probabilidadeAtual = valorNumerico;
    if (campo === 'frequencia') risco.frequenciaAtual = valorNumerico;
    if (campo === 'gravidade') risco.gravidadeAtual = valorNumerico;
    if (campo === 'exposicao') risco.exposicaoAtual = valorNumerico;
    
    // Garantir que todos os valores sejam números válidos
    const po = Number(risco.probabilidadeAtual) ?? 1;
    const fe = Number(risco.frequenciaAtual) ?? 1;
    const gs = Number(risco.gravidadeAtual) ?? 1;
    const np = Number(risco.exposicaoAtual) ?? 1;
    risco.hrnAtual = calcularHRN(po, fe, gs, np);
  } else {
    if (campo === 'probabilidade') risco.probabilidadeFuturo = valorNumerico;
    if (campo === 'frequencia') risco.frequenciaFuturo = valorNumerico;
    if (campo === 'gravidade') risco.gravidadeFuturo = valorNumerico;
    if (campo === 'exposicao') risco.exposicaoFuturo = valorNumerico;
    
    // Garantir que todos os valores sejam números válidos
    const po = Number(risco.probabilidadeFuturo ?? risco.probabilidadeAtual) ?? 1;
    const fe = Number(risco.frequenciaFuturo ?? risco.frequenciaAtual) ?? 1;
    const gs = Number(risco.gravidadeFuturo ?? risco.gravidadeAtual) ?? 1;
    const np = Number(risco.exposicaoFuturo ?? risco.exposicaoAtual) ?? 1;
    risco.hrnFuturo = calcularHRN(po, fe, gs, np);
  }
  
  setRiscosEditados(novosRiscos);
};

